import useTranslation from '../../hooks/useTranslation';
import FieldRow from '../FieldRow';

import { VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const ApplicatorSection: FunctionComponent<Props> = ({ application, testId = TEST_ID }) => {
    const translations = useTranslation();

    return (
        <VerticalContainer className={styles.applicatorSection} testId={testId}>
            <Wrapper className={styles.sectionHeader}>{translations.APPLICATOR}</Wrapper>

            <FieldRow label={translations.APPLICATOR_NAME} value={application.applicatorName} />

            <FieldRow label={translations.LICENSE} value={application.applicatorLicense} />

            <FieldRow
                label={translations.LICENSE_STATE}
                value={application.applicatorLicenseState}
            />

            <FieldRow
                label={translations.APPLICATOR_TYPE_LABEL}
                value={application.applicatorType}
            />
        </VerticalContainer>
    );
};

export default ApplicatorSection;
